import { useEffect, useRef } from "react";
import { CloseBtn, FormUi, Modal, SaveBtn } from "../../../ui";
import { Form } from "antd";
import { ItemForm } from "./ItemForm";
const initialValues = {
  items: [],
  fileExcel: [],
};
const useResetFormOnCloseModal = ({ form, open }) => {
  const prevOpenRef = useRef();
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;
  useEffect(() => {
    if (!open && prevOpen) {
      form.resetFields();
    }
  }, [form, prevOpen, open]);
};
export const ItemModal = ({ open, handleClose }) => {
  const [form] = Form.useForm();
  const items = Form.useWatch("items", form);
  useResetFormOnCloseModal({ form, open });
  return (
    <Modal
      title="Agregar items"
      centered
      maskClosable={false}
      destroyOnHidden
      open={open}
      onCancel={handleClose}
      width="60%"
      footer={[
        <CloseBtn key="back" onClick={handleClose} />,
        <SaveBtn
          key="submit"
          htmlType="submit"
          form="FormItemsDetalle"
          disabled={items?.length === 0}
        />,
      ]}
    >
      <FormUi
        name="FormItemsDetalle"
        form={form}
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues}
        handleSubmit={handleClose}
      >
        <ItemForm />
      </FormUi>
    </Modal>
  );
};
